import classNames from "classnames/bind";
import { IconComponent, IconComponentObject, IconColours } from "./interface";
import classes from "./icons.module.scss";

// Import all the icons
import Add from "./Assets/Add";
import Close from "./Assets/Close";
import Check from "./Assets/Check";
import Arrow from "./Assets/Arrow";
import Circle from "./Assets/Circle";
import Left from "./Assets/Left";
import Right from "./Assets/Right";
import Play from "./Assets/Play";
import ClosedCaptions from "./Assets/ClosedCaptions";
import Hamburger from "./Assets/Hamburger";
import ImageIcon from "./Assets/ImageIcon";
import Link from "./Assets/Link";
import Customize from "./Assets/Customize";

/* Map of icon name to component name to render,
this will be used when calling the Icon component from stories and other components */

export enum IconNames {
    Add = "Add",
    Close = "Close",
    Check = "Check",
    Arrow = "Arrow",
    Circle = "Circle",
    Left = "Left",
    Right = "Right",
    Play = "Play",
    ClosedCaptions = "ClosedCaptions",
    Hamburger = "Hamburger",
    ImageIcon = "ImageIcon",
    Link = "Link",
    Customize = "Customize",
}

/* Map of icon name to component name to render
This will be used to render the icon component below with dynamic Icon component names
*/
const IconComponents: IconComponentObject = {
    Add,
    Close,
    Check,
    Arrow,
    Circle,
    Left,
    Right,
    Play,
    ClosedCaptions,
    Hamburger,
    ImageIcon,
    Link,
    Customize,
};

const Icon = ({
    name,
    title,
    className,
    size = "24",
    colour = IconColours.black,
    secondaryColour = IconColours.white,
    type = "filled",
    ariaHidden = false,
}: IconComponent) => {
    const IconComponent: IconComponentObject[keyof IconComponentObject] =
        IconComponents[name];
    if (!IconComponent) {
        throw Error(`Unrecognised Icon name: ${name}`);
    }

    const cx = classNames.bind(classes);
    const iconClasses = cx("icon", [type], className);

    return (
        <IconComponent
            size={size}
            className={iconClasses}
            colour={colour}
            secondaryColour={secondaryColour}
            title={title}
            ariaHidden={ariaHidden}
            type={type}
        />
    );
};
// This will allow us to pass appropriate Icon component as name variable to the Icon component
Icon.Names = IconNames;
export default Icon;
